<template>
  <v-container fluid>
    <h4 class="mt-4 text-center">
      BẢNG {{ billType.toUpperCase() }} NHÀ NƯỚC
      <span v-if="tableTitleDate">THÁNG {{ tableTitleDate }}</span>
    </h4>
    <v-data-table :items="displayingItems" hide-headers hide-actions>
      <template slot="items" slot-scope="props">
        <template v-if="props.item.isHeaderRow">
          <tr class="text-no-wrap">
            <td class="text-xs-center font-weight-bold">Toà nhà</td>
            <td class="text-xs-center font-weight-bold">Mã KH</td>
            <td class="text-xs-right font-weight-bold">Số đầu kỳ</td>
            <td class="text-xs-right font-weight-bold">Số cuối kỳ</td>
            <td class="text-xs-right font-weight-bold">Số tiêu thụ</td>
            <td class="text-xs-right font-weight-bold">Đơn giá {{ billType === 'Nước' ? 'nước' : 'điện' }}</td>
            <td class="text-xs-right font-weight-bold">Số tiền đã nộp</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td
              :class="{ 'text-center text-no-wrap': true, 'sub-row-cell': props.item.isSubRow, 'font-weight-bold': props.item.isTotalRow }">
              {{ props.item.building }}
            </td>
            <td
              :class="{ 'text-center text-no-wrap': true, 'sub-row-cell': props.item.isSubRow, 'font-weight-bold': props.item.isTotalRow }">
              {{ props.item.customer_code }}
            </td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.previous_period === null ? '' :
                $options.filters.formatNumber(props.item.previous_period) }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">
              {{ props.item.current_period === null ? '' :
                $options.filters.formatNumber(props.item.current_period) }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.consumption === null ? '' :
                $options.filters.formatNumber(props.item.consumption) }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.unit_price === null ? '' :
                $options.filters.formatNumber(Math.round(props.item.unit_price)) }}</td>
            <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
              props.item.amount_paid === null ? '' :
                $options.filters.formatCurrency(props.item.amount_paid) }}</td>
          </tr>
        </template>
      </template>

      <template slot="no-data">
        Không có dữ liệu
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import api from 'Api';
import { buildParamQuery, formatCurrency } from "Helpers";
import * as XLSX from 'xlsx';
import { list_building } from 'Constants/db-config'

export default {
  name: 'table-dien-nuoc-nha-nuoc',
  props: {
    dateStart: {
      type: String,
      default: ''
    },
    dateEnd: {
      type: String,
      default: ''
    },
    billType: {
      type: String,
      default: 'Nước'
    },
    reloadTrigger: {
      type: Number,
      default: 0
    },
    export_csv: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      rawExtractedData: [],
      tableTitleDate: '',
      list_building,
      formatCurrency
    };
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('vi-VN');
    },
    formatMonthYear(value) {
      if (!value) return '';
      const date = new Date(value);
      return `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    },
  },
  computed: {
    processedItems() {
      const dataByBuilding = this.rawExtractedData.reduce((acc, item) => {
        (acc[item.building] = acc[item.building] || []).push(item);
        return acc;
      }, {});

      const flattenedItems = [];

      this.list_building.map(item => item.value).forEach(buildingName => {
        const buildingData = dataByBuilding[buildingName];

        if (buildingData && buildingData.length > 0) {
          buildingData.forEach((item, index) => {
            flattenedItems.push({
              building: index === 0 ? item.building : '',
              customer_code: item.customer_code,
              previous_period: item.previous_period || 0,
              current_period: item.current_period || 0,
              consumption: item.consumption || 0,
              unit_price: item.unit_price || 0,
              amount_paid: item.amount_paid || 0,
              isSubRow: index !== 0,
              isFirstHeaderRow: false,
              isHeaderRow: false
            });
          });
        } else {
          flattenedItems.push({
            building: buildingName,
            customer_code: '',
            previous_period: null,
            current_period: null,
            consumption: null,
            unit_price: null,
            amount_paid: null,
            isSubRow: false,
            isFirstHeaderRow: false,
            isHeaderRow: false
          });
        }
      });
      return flattenedItems;
    },
    displayingItems() {
      if (!this.processedItems.length) return [];

      const items = [];

      items.push({ isHeaderRow: true });

      items.push(...this.processedItems);

      const totalRow = {
        building: null,
        customer_code: "Tổng",
        previous_period: null,
        current_period: null,
        consumption: this.totalConsumption,
        unit_price: null,
        amount_paid: this.totalAmountPaid,
        isTotalRow: true,
        isFirstHeaderRow: false,
        isHeaderRow: false
      };

      items.push(totalRow);
      return items;
    },
    totalConsumption() {
      return this.rawExtractedData.reduce((sum, item) => sum + (item.consumption || 0), 0);
    },
    totalAmountPaid() {
      return this.rawExtractedData.reduce((sum, item) => sum + (item.amount_paid || 0), 0);
    },
  },
  watch: {
    dateStart: 'fetchData',
    dateEnd: 'fetchData',
    billType: 'fetchData',
    reloadTrigger: 'fetchData',
    export_csv: 'exportCSV'
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.dateStart || !this.dateEnd || !this.billType) {
        this.rawExtractedData = [];
        return;
      }

      const params = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        type: this.billType
      };

      const query = buildParamQuery(params);
      try {
        const response = await api.getStateElectricityWaterBills(query);
        this.rawExtractedData = response.data.data;
        if (this.dateEnd) {
          this.tableTitleDate = this.$options.filters.formatMonthYear(this.dateEnd);
        } else if (this.dateStart) {
          this.tableTitleDate = this.$options.filters.formatMonthYear(this.dateStart);
        }
      } catch (error) {
        console.error("Lỗi khi lấy dữ liệu hóa đơn:", error);
        this.rawExtractedData = [];
      }
    },
    exportCSV() {
      if (!this.displayingItems.length) {
        alert('Không có dữ liệu để xuất CSV.');
        return;
      }

      const dataForExport = [];

      dataForExport.push([
        'Toà nhà', 'Mã KH',
        'Số đầu kỳ', 'Số cuối kỳ', 'Số tiêu thụ',
        `Đơn giá ${this.billType === 'Nước' ? 'nước' : 'điện'}`,
        'Số tiền đã nộp',
      ]);

      this.displayingItems.forEach(item => {
        if (!item.isHeaderRow) {
          const row = [];
          row.push(item.building, item.customer_code);

          row.push(
            item.previous_period === null ? '' : item.previous_period,
            item.current_period === null ? '' : item.current_period,
            item.consumption === null ? '' : item.consumption,
            item.unit_price === null ? '' : item.unit_price,
            item.amount_paid === null ? '' : item.amount_paid
          );

          dataForExport.push(row);
        }
      });

      const ws = XLSX.utils.aoa_to_sheet(dataForExport);

      const wscols = [
        { wch: 15 }, { wch: 15 },
        { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 15 }, { wch: 18 }
      ];
      ws['!cols'] = wscols;

      const csv = XLSX.utils.sheet_to_csv(ws);

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const title = `Bảng điện nước nhà nước ${this.billType.toUpperCase()}`;
      const dateRange = this.tableTitleDate ? `Tháng ${this.tableTitleDate}` : '';
      const fileName = `${title.replace(/\s/g, '_')}_${dateRange.replace(/\s/g, '_').replace(/\//g, '-')}.csv`;

      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
      }
    }
  }
};
</script>

<style scoped>
.table-analysis th {
  white-space: nowrap;
  font-weight: bold;
  border: 1px solid #e0e0e0;
  height: auto !important;
  padding: 8px 16px;
}

.table-analysis td {
  border: 1px solid #e0e0e0;
  vertical-align: top;
  padding: 8px 16px;
}

.table-analysis td.sub-row-cell {
  border-top: none;
  border-bottom: none;
  background-color: #f9f9f9;
}

.fw-bold {
  font-weight: bold;
}

.total-row-background {
  background-color: #f5f5f5;
}
</style>